export type BookingStatus =
  | "pending"
  | "awaiting_owner_approval"
  | "approved"
  | "declined"
  | "paid"
  | "active"
  | "completed"
  | "cancelled"
  | "refunded";

export type AppRole = "guest" | "shop" | "admin" | "user";

export const ALL_BOOKING_STATUSES: BookingStatus[] = [
  "pending",
  "awaiting_owner_approval",
  "approved",
  "declined",
  "paid",
  "active",
  "completed",
  "cancelled",
  "refunded",
];

export const NEXT_STATUS_MAP: Record<BookingStatus, BookingStatus[]> = {
  pending: ["awaiting_owner_approval", "cancelled"],
  awaiting_owner_approval: ["approved", "declined"],
  approved: ["paid", "cancelled"],
  declined: [],
  paid: ["active", "cancelled", "refunded"],
  active: ["completed"],
  completed: [],
  cancelled: ["refunded"],
  refunded: [],
};

export function getAllowedStatusesByRole(
  currentStatus: BookingStatus,
  role: AppRole,
): BookingStatus[] {
  const next = NEXT_STATUS_MAP[currentStatus] || [];

  // Admin override (can set any status)
  if (role === "admin") return ALL_BOOKING_STATUSES;

  // Business owner / shop
  if (role === "shop") {
    return next.filter((s) =>
      [
        "approved",
        "declined",
        "paid",
        "active",
        "completed",
        "cancelled",
      ].includes(s),
    );
  }

  // Customer / guest
  if (role === "guest" || role === "user") {
    return next.filter((s) => ["cancelled"].includes(s));
  }

  return [];
}

export function prettyStatus(status: string) {
  return String(status || "").replaceAll("_", " ");
}

export function statusColor(status: string) {
  const map: Record<string, string> = {
    pending: "gray",
    awaiting_owner_approval: "yellow",
    approved: "green",
    declined: "red",
    paid: "blue",
    active: "purple",
    completed: "green",
    cancelled: "orange",
    refunded: "teal",
  };
  return map[status] || "gray";
}
